import React from "react";
import { Route, IndexRoute } from "react-router";

//messages components
import MessagesContainer from "../components/dashboard/MessagesContainer";
import Inbox from "../components/common/Inbox";
import ComposeContainer from "../components/common/ComposeContainer";
import SentMessages from "../components/common/SentMessages";
import ReadMessage from "../components/common/ReadMessage";
import BroadcastInbox from "../components/common/BroadcastInbox";
import BroadcastedMessages from "../components/manager/BroadcastedMessages";
import EmailsInbox from "../components/manager/EmailsInbox";
import SmsInbox from "../components/manager/SmsInbox";

export const messagesRoutes = (
  <Route path="messages" component={MessagesContainer}>
    <IndexRoute component={Inbox} />
    <Route path="broadcasts-inbox" component={BroadcastInbox} />
    <Route path="sent" component={SentMessages} />
    <Route path="broadcasts" component={BroadcastedMessages} />
    <Route path="emails" component={EmailsInbox} />
    <Route path="sms" component={SmsInbox} />
    <Route path=":type/read/:messageId" component={ReadMessage} />
    <Route path="compose" component={ComposeContainer} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes/messagesRoutes.js